import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import {
  ContextService,
  LabelsService,
  Language,
  provideAiguillage,
  provideLocaleId,
  provideOverlayContainer,
  provideTypology,
  withApimInterceptors,
} from '@bcef/ia-shared';
import { provideInfoClient } from '@bcef/ia-shared/info-client';
import { provideDataLayer } from '@difa/ia-data-layer';
import { provideTypologyFileUrl } from '@difa/ia-typology-files';
import { provideJsonConvert } from '@difa/ia-utils';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';

import { environment } from '@environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideStore(
      {
        router: routerReducer,
      },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: false,
          strictActionSerializability: false,
        },
      },
    ),
    environment.providers,
    provideRouterStore({
      stateKey: 'router',
    }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled',
      }),
      // turn this to `true` if you want to enable 'fondu enchaîné' effect when navigating.
      // withViewTransitions({ skipInitialTransition: true }),
    ),
    provideInfoClient(),
    provideAiguillage(),
    provideTranslateService({
      fallbackLang: Language.FR,
      loader: provideTranslateLoader(LabelsService),
    }),
    provideLocaleId(),
    provideTypology(),
    provideTypologyFileUrl(() => {
      const context = inject(ContextService);
      return `/apps/ia-make-complaint/labels/ia-make-complaint-${context.language}-${context.typology}.json`;
    }),
    provideDataLayer({
      serviceName: 'Assistance',
      prefix: 'dataLayer',
      // turn this property to `true` if you want to log warnings in the
      // console if some of your DataLayer objects
      // are formatted properly (only in development mode)
      // it needs the `prefix` property to be set in order to work
      checkDataLayerObjectsIntegrity: false,
    }),
    provideAppInitializer(() => inject(LabelsService).getTranslation()),
    provideHttpClient(withInterceptorsFromDi(), withApimInterceptors()),
    provideJsonConvert(),
    provideOverlayContainer(),
  ],
};
